import React from "react";
import './index.less'

export default function (dataItems, item) {
  const formatName = () => {
    let desc = ''
    if (item == 0) {
      desc = '课程名称'
    } else if (item == 1) {
      desc = '考试名称'
    } else if (item == 8) {
      desc = '主题名称'
    } else if (item == 30) {
      desc = '作业名称'
    } else if (item == 12) {
      desc = '路径名称'
    }
    return desc
  }

  return [
    {
      title: formatName(),
      name: 'conditionBizName',
      tableItem: {
        render: (text, record, index) => record.trainPathName ? `${record.trainPathName}->${record.conditionBizName}` : text
      }
    },
    {
      title: '条件',
      name: 'conditionType',
      tableItem: {
        width: 150,
        render: (text, record, index) => {
          return (<div className="view-label-and-or-box">
            <div>通过状态</div>
            {index == 0 ?
              null :
              <div className="and-or">
                <span> {text === 0 ? '与' : '或'} </span>
              </div>}
          </div>)
        }
      }
    },
    {
      title: '值',
      name: 'conditionActionType',
      tableItem: {
        width: 150,
        render: (text, record, index) => <span> {text === 0 ? '未通过' : '通过'}</span>
      }
    },
    {
      title: '状态',
      name: '',
      tableItem: {
        width: 150,
        render: (text, record, index) => {
          return (
            <span>已发布</span>
          )
        }
      },
    },
  ]
}
